var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('vs-button',{staticClass:"my-1 mx-2",attrs:{"disabled":_vm.isDisabled,"size":"small","color":"#00a4e4","type":"filled"},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }